export enum RolAutoridad {
  SISTEMA = 'SISTEMA',
  PROPIETARIO = 'PROPIETARIO',
  ADMINISTRADOR = 'ADMINISTRADOR',
  SOLICITANTE = 'SOLICITANTE',
  OPERADOR = 'OPERADOR',
  REVISOR = 'REVISOR',
  APROBADOR = 'APROBADOR',
  SOPORTE = 'SOPORTE',
  VALIDADOR_DOCUMENTAL = 'VALIDADOR_DOCUMENTAL',
  DIRECTOR = 'DIRECTOR',
  JEFE_DEPARTAMENTO = 'JEFE_DEPARTAMENTO',
  SUBDIRECTOR = 'SUBDIRECTOR',
  APOYO = 'APOYO',
  COORDINADOR_PROGRAMA = 'COORDINADOR_PROGRAMA',
  ASISTENTE_COORDINADOR = 'ASISTENTE_COORDINADOR',
  BECARIO = 'BECARIO',
  ALUMNO = 'ALUMNO',
  PROFESOR = 'PROFESOR',
  AYUDANTE = 'AYUDANTE',
  AUDITOR = 'AUDITOR',
  COORDINADOR_INSTITUCIONAL = 'COORDINADOR_INSTITUCIONAL',
  ASISTENTE_COORDINADOR_INSTITUCIONAL = 'ASISTENTE_COORDINADOR_INSTITUCIONAL',
  ASISTENTE_COMISION = 'ASISTENTE_COMISION',
  LIDER_COMISIONES = 'LIDER_COMISIONES',
  REPORTES = 'REPORTES',
}
